import Footer from './FooterContainer'

export default Footer
